import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { useContext, useState, useEffect } from 'react';
import dataRoomApi from 'router/subrouters/DataRoom/dataRoomApi';
import { Question } from 'router/subrouters/DataRoom/models/QAndA';

const FOLLOW_UP_LIMIT = 100;

const useGetFollowUpQuestion = (question: Question, canFetch?: boolean) => {
  const {
    _id,
    createdAt,
    dataRoomParentQuestionId,
    dataRoomParentQuestion,
    dataRoomLatestFollowupQuestion,
    dataRoomPreviousFollowupQuestion,
  } = question;

  const { popServerError } = useContext(PopNotificationsContext);

  const [displayedQuestions, setDisplayedQuestions] = useState<Question[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const hasFollowUpQuestion =
    !!dataRoomLatestFollowupQuestion ||
    !!dataRoomPreviousFollowupQuestion ||
    !!dataRoomParentQuestion;

  const originalQuestion = dataRoomParentQuestion || question;

  useEffect(() => {
    (async () => {
      if (canFetch) {
        setIsLoading(true);

        try {
          if (hasFollowUpQuestion) {
            const followUpId = dataRoomParentQuestionId || _id;
            const followUpCreatedAt =
              dataRoomLatestFollowupQuestion?.createdAt || createdAt;

            const {
              data: { items },
            } = await dataRoomApi.questionsAndAnswers.getFollowUpQuestions(
              followUpId,
              followUpCreatedAt,
              { $limit: `${FOLLOW_UP_LIMIT}` },
            );
            setDisplayedQuestions([
              originalQuestion,
              ...(items || []).reverse(),
            ]);
          } else {
            setDisplayedQuestions([question]);
          }
        } catch (e) {
          popServerError(e);
        } finally {
          setIsLoading(false);
        }
      }
    })();
  }, [
    _id,
    canFetch,
    createdAt,
    dataRoomLatestFollowupQuestion?.createdAt,
    dataRoomParentQuestionId,
    hasFollowUpQuestion,
    originalQuestion,
    popServerError,
    question,
    setIsLoading,
  ]);

  return {
    isLoading,
    displayedQuestions,
  };
};

export default useGetFollowUpQuestion;
